module.exports = __webpack_public_path__ + "static/media/unval-label.a950ce88.png";